import { vuexEventPathGenerator } from '@/utils';
import { mutationType } from './mutations';
export const actionType = {
    setIsOpenModalWorkerInfo: 'setIsOpenModalWorkerInfo',
    clearModalWorkerData: 'clearModalWorkerData',
};
export const modalWorkerInfoActionType = vuexEventPathGenerator(actionType, 'modalWorkerInfo');
const action = {
    [actionType.setIsOpenModalWorkerInfo]({ commit }, workerCode) {
        commit(mutationType.SET_IS_OPEN_MODAL_WORKER_INFO, workerCode);
    },
    [actionType.clearModalWorkerData]() { },
};
export default action;
